import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FiHome, FiArrowLeft } from 'react-icons/fi'

const NotFoundPage: React.FC = () => {
    const navigate = useNavigate()

    return (
        <>
            <Helmet>
                <title>Page Not Found - SideGO</title>
                <meta name="description" content="The page you're looking for doesn't exist." />
            </Helmet>

            <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
                <div className="max-w-md w-full bg-white dark:bg-gray-800 shadow-lg rounded-lg p-8 mx-4 text-center">
                    <div className="flex items-center justify-center w-16 h-16 bg-red-100 dark:bg-red-900/20 rounded-full mx-auto mb-6">
                        <span className="text-4xl font-bold text-red-600 dark:text-red-400">404</span>
                    </div>

                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
                        Page Not Found
                    </h1>
                    <p className="text-gray-600 dark:text-gray-400 mb-8">
                        Sorry, the page you're looking for doesn't exist or may have been moved.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-3 justify-center">
                        <button
                            onClick={() => navigate(-1)}
                            className="inline-flex items-center px-4 py-2 bg-gray-600 hover:bg-gray-700 text-white rounded-md font-medium transition-colors duration-200"
                        >
                            <FiArrowLeft className="mr-2 w-4 h-4" />
                            Go Back
                        </button>
                        <Link
                            to="/"
                            className="inline-flex items-center px-4 py-2 bg-primary-600 hover:bg-primary-700 text-white rounded-md font-medium transition-colors duration-200"
                        >
                            <FiHome className="mr-2 w-4 h-4" />
                            Go Home
                        </Link>
                    </div>
                </div>
            </div>
        </>
    )
}

export default NotFoundPage